"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import get from "../data/get";
import Address from "./address";
import ReactUtils from "../../react_utils";
import generalFormatter from "../../formatters/general";
import { HoverableValueMixin } from "../hoverable_value_mixin";
import TmsDeletedWarningIcon from "../load_tms_deleted_warning";
import { cleanReference } from "../../helpers/references";
const bem = ReactUtils.makeBem("load-detail");
function groupByShipment({ stops, shipments }) {
  return shipments.map((shipment) => __spreadProps(__spreadValues({}, shipment), {
    stops: stops.filter((stop) => stop.tms_shipment_ids.indexOf(shipment.id) !== -1).sort(
      (a, b) => new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime()
    )
  }));
}
function isDropType(stop) {
  return stop.type === "TMS::Drop";
}
function calculateDropNumber({ shipments, shipmentIndex, stopIndex }) {
  const previousDropsInPreviousShipments = shipments.slice(0, shipmentIndex).map((shipment) => shipment.stops.filter(isDropType).length).reduce((a, b) => a + b, 0);
  const previousDropsInCurrentShipment = shipments[shipmentIndex].stops.slice(0, stopIndex).filter(isDropType).length;
  return previousDropsInPreviousShipments + previousDropsInCurrentShipment + 1;
}
function formatStopType(stop) {
  return stop.type.substr("TMS::".length).toUpperCase();
}
function formatStopLabel({ stop, number }) {
  if (number !== void 0) {
    return `${formatStopType(stop)} ${number}`;
  } else {
    return formatStopType(stop);
  }
}
function tbodyClasses(index) {
  return bem({ even: index % 2 === 0 });
}
function rowClasses(index) {
  return bem({ "__info-table-data": true, even: index % 2 === 0 });
}
function dropReferences(tmsDrop) {
  return _.map(tmsDrop.references, (v, k) => {
    const value = s.toSentenceSerial(_.flatten([v]));
    return /* @__PURE__ */ React.createElement("div", null, k, ": ", value);
  });
}
function maybeShipmentNotesRow(tmsShipment) {
  return tmsShipment.shipment_notes && tmsShipment.shipment_notes.length > 0 && /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 2, className: bem("__shipment_notes_row") }, /* @__PURE__ */ React.createElement("div", { className: bem("__info-reference-pair") }, /* @__PURE__ */ React.createElement("span", { className: bem("__info-reference-name") }, "Shipment Notes:"), tmsShipment.shipment_notes.map((x, i) => /* @__PURE__ */ React.createElement("p", { key: `shipment-note-${tmsShipment.id}-${i}` }, /* @__PURE__ */ React.createElement("span", { className: bem("__info-reference-value") }, x))))));
}
function extraShipmentReferences(tmsShipment) {
  const refs = [];
  _.each(tmsShipment.references, (value, name) => {
    refs.push({
      name,
      value
    });
  });
  return refs;
}
export default React.createClass({
  mixins: [HoverableValueMixin],
  getInitialState: function() {
    return {};
  },
  render: function() {
    const shipments = groupByShipment({
      stops: get.tmsStops(this.props.load),
      shipments: get.tmsShipments(this.props.load)
    });
    if (shipments.length > 0) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
        "table",
        {
          className: bem("__info-table", "__info-table-with-references")
        },
        /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: bem("__info-table-header") }, /* @__PURE__ */ React.createElement("th", null, "Shipment"), /* @__PURE__ */ React.createElement("th", null, "Stops"))),
        shipments.map(this.viewShipment)
      )));
    }
    return null;
  },
  viewShipment(shipment, shipmentIndex, shipments) {
    return /* @__PURE__ */ React.createElement(
      "tbody",
      {
        className: tbodyClasses(shipmentIndex),
        key: `drop_info_${shipment.id}`
      },
      /* @__PURE__ */ React.createElement("tr", { className: bem("__info-table-data") }, /* @__PURE__ */ React.createElement("td", { className: bem("__info-with-references") }, this.shipmentReferences(shipment)), /* @__PURE__ */ React.createElement("td", { className: bem("__align-top") }, /* @__PURE__ */ React.createElement("table", { className: bem("__full-width") }, /* @__PURE__ */ React.createElement("tbody", null, shipment.stops.map((stop, stopIndex) => {
        const number = isDropType(stop) ? calculateDropNumber({
          stopIndex,
          shipmentIndex,
          shipments
        }) : void 0;
        const stopLabel = formatStopLabel({ stop, number });
        return this.viewStopRow({
          stopIndex,
          stop,
          shipment,
          stopLabel
        });
      }))))),
      maybeShipmentNotesRow(shipment)
    );
  },
  viewStopRow({ stopIndex, stop, shipment, stopLabel }) {
    let tmsDeletedIcon;
    if (stop.tms_deleted) {
      tmsDeletedIcon = /* @__PURE__ */ React.createElement(TmsDeletedWarningIcon, null);
    }
    return /* @__PURE__ */ React.createElement(
      "tr",
      {
        className: rowClasses(stopIndex + 1),
        key: `drop_info_${shipment.id}_${stop.id}`
      },
      /* @__PURE__ */ React.createElement("td", { className: bem("__align-top") }, stopLabel, " ", tmsDeletedIcon),
      /* @__PURE__ */ React.createElement("td", { className: bem("__align-top") }, /* @__PURE__ */ React.createElement(
        Address,
        {
          source: stop,
          onValueHighlighted: this.props.onValueHighlighted,
          onValueClick: this.props.onValueClick
        }
      ), "Weight: ", generalFormatter.weight(stop.weight) || "Unknown", dropReferences(stop))
    );
  },
  shipmentReferences: function(tmsShipment) {
    const references = [
      { name: "Shipment", value: tmsShipment.shipment_id }
    ];
    if (tmsShipment.actual_shipped_at) {
      references.push({
        name: "Pick-up Date",
        value: generalFormatter.dateTime(tmsShipment.actual_shipped_at)
      });
    }
    if (tmsShipment.actual_delivered_at) {
      references.push({
        name: "Drop-off Date",
        value: generalFormatter.dateTime(tmsShipment.actual_delivered_at)
      });
    }
    if (tmsShipment.weight) {
      references.push({
        name: "Weight",
        value: generalFormatter.weight(tmsShipment.weight)
      });
    }
    if (tmsShipment.po) {
      references.push({ name: "PO Number", value: tmsShipment.po });
    }
    if (tmsShipment.pickup_reference) {
      references.push({
        name: "Pickup Reference",
        value: tmsShipment.pickup_reference
      });
    }
    if (tmsShipment.ship_ref) {
      references.push({
        name: "Shipment Reference",
        value: tmsShipment.ship_ref
      });
    }
    if (tmsShipment.shipper && tmsShipment.shipper.name) {
      references.push({
        name: "Shipper Name",
        value: tmsShipment.shipper.name
      });
    }
    if (tmsShipment.customer && tmsShipment.customer.name) {
      references.push({ name: "Customer", value: tmsShipment.customer.name });
    }
    extraShipmentReferences(tmsShipment).forEach((ref) => {
      references.push(ref);
    });
    const html = references.map(cleanReference).map((ref) => {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: bem("__info-reference-pair"),
          key: `shipment-reference-${ref.name}`
        },
        /* @__PURE__ */ React.createElement("span", { className: bem("__info-reference-name") }, ref.name, ":"),
        /* @__PURE__ */ React.createElement("span", { className: bem("__info-reference-value") }, this.showValue(ref.value))
      );
    });
    return /* @__PURE__ */ React.createElement("div", null, html);
  },
  showValue(value) {
    if (this.props.onValueHighlighted) {
      return this.showHoverableValue(value);
    } else {
      return /* @__PURE__ */ React.createElement("span", null, value);
    }
  }
});
